/** Root key of the calendar's action-item queries, kept dependency-free so mutations can invalidate it. */
export const CALENDAR_ACTION_ITEMS_QUERY_KEY = 'actionItem/filter';
